import { createContext, PropsWithChildren, useContext } from 'react';
import { QueryObserverResult, RefetchOptions, RefetchQueryFilters } from '@tanstack/react-query';
import { usePlanSpaceDetail } from '../../../../services';
import { SpaceWithPlanDetail } from '../../../../types';
type PlanSpaceDetailContextType = SpaceWithPlanDetail & {
  refetchPlanDetails: <TPageData>(options?: RefetchOptions & RefetchQueryFilters<TPageData>) => Promise<QueryObserverResult<SpaceWithPlanDetail, never>>;
};
const PlanSpaceDetailContext = createContext<PlanSpaceDetailContextType | null>(null);
export const usePlanSpaceDetailContext = () => {
  const context = useContext(PlanSpaceDetailContext);
  if (!context) {
    throw new Error('usePlanSpaceDetailContext must be used within a PlanSpaceDetailProvider');
  }
  return context;
};
export const PlanSpaceDetailProvider = ({
  children,
  spaceHashId
}: PropsWithChildren<{
  spaceHashId: string;
}>) => {
  const planSpaceDetailQuery = usePlanSpaceDetail(spaceHashId);
  return <PlanSpaceDetailContext.Provider value={{
    ...planSpaceDetailQuery.data,
    refetchPlanDetails: planSpaceDetailQuery.refetch
  }} data-sentry-element="unknown" data-sentry-component="PlanSpaceDetailProvider" data-sentry-source-file="PlanSpaceDetailProvider.tsx">
      {children}
    </PlanSpaceDetailContext.Provider>;
};